module.exports = __webpack_public_path__ + "static/media/A label.d0afd73e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/A label.png
// module id = 979
// module chunks = 0